<template>
  <v-container fill-height>
    <v-row class="d-flex justify-center">
      <v-col lg="12" md="12" sm="12" cols="12">
        <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="submit" class="pa-4">
          <v-card elevation="0">
            <v-toolbar flat class="mb-3">
              <v-toolbar-title class="flex text-center font-weight-black"> ข้อมูลส่วนตัว (Personal information) </v-toolbar-title>
              <v-btn color="orange" dark depressed small @click="dialog = true">
                <v-icon left small>mdi-account-search</v-icon>
                เลือกโปรไฟล์
              </v-btn>
            </v-toolbar>

            <!-- Line 2 ---------------------------------------------------------------------------------->
            <v-row>
              <v-col class="pb-0 pt-0" lg="4" md="4" sm="12" cols="12">
                <!-- ชื่อ  (ภาษาไทย) ------------------------------>
                <p class="font-weight-black">ชื่อ - นามสกุล</p>
                <v-text-field v-model="fullname" :rules="TextRule" label="ชื่อ..." single-line dense outlined clearable required></v-text-field>
                <!-- ชื่อ  (ภาษาไทย) ------------------------------>
              </v-col>
              <v-col class="pb-0 pt-0" lg="4" md="4" sm="12" cols="12">
                <!-- นามสกุล (ภาษาไทย) --------------------------->
                <p class="font-weight-black">ระดับชั้น</p>
                <v-text-field v-model="std_level" filled disabled single-line dense outlined></v-text-field>
                <!-- นามสกุล (ภาษาไทย) --------------------------->
              </v-col>
              <v-col class="pb-0 pt-0" lg="4" md="4" sm="12" cols="12">
                <p class="font-weight-black">ประเภทวิชา</p>
                <v-text-field v-model="division" filled disabled single-line dense outlined></v-text-field>
              </v-col>
            </v-row>
            <!-- Line 2 ---------------------------------------------------------------------------------->
            <!-- Line 3 ---------------------------------------------------------------------------------->
            <v-row>
              <v-col class="pb-0 pt-0" lg="4" md="4" sm="12" cols="12">
                <p class="font-weight-black">สาขาวิชา</p>
                <v-text-field v-model="department" filled disabled single-line dense outlined></v-text-field>
              </v-col>
              <v-col class="pb-0 pt-0" lg="4" md="4" sm="12" cols="12">
                <p class="font-weight-black">สาขางาน</p>
                <v-text-field v-model="concentrate" filled disabled single-line dense outlined></v-text-field>
              </v-col>
              <v-col class="pb-0 pt-0" lg="4" md="4" sm="12" cols="12">
                <p class="font-weight-black">ภาค</p>
                <v-text-field v-model="zone" filled disabled single-line dense outlined></v-text-field>
              </v-col>
            </v-row>
            <!-- Line 3 ---------------------------------------------------------------------------------->
            <v-divider class="mt-5"></v-divider>
          </v-card>
          <!-- card 2 ------------------------------------------------------------------------------------------------------------>
          <v-card elevation="0">
            <v-toolbar flat class="mb-3">
              <v-toolbar-title class="flex text-center font-weight-black"> ช่องทางการติดต่อ (Contact) </v-toolbar-title>
            </v-toolbar>

            <!-- Line 1 ---------------------------------------------------------------------------------->
            <v-row>
              <v-col class="pb-0 pt-0" lg="3" md="3" sm="12" cols="12">
                <p class="font-weight-black">ที่อยู่</p>
                <v-text-field
                  v-model="student_address"
                  :rules="TextRule"
                  label="ที่อยู่..."
                  single-line
                  dense
                  outlined
                  clearable
                  required
                ></v-text-field>
              </v-col>
              <v-col class="pb-0 pt-0" lg="2" md="2" sm="12" cols="12">
                <p class="font-weight-black">หมู่</p>
                <v-text-field v-model="student_moo" :rules="TextRule" label="หมู่..." single-line dense outlined clearable required></v-text-field>
              </v-col>
              <v-col class="pb-0 pt-0" lg="2" md="2" sm="12" cols="12">
                <p class="font-weight-black">ซอย</p>
                <v-text-field v-model="student_soi" :rules="TextRule" label="ซอย..." single-line dense outlined clearable required></v-text-field>
              </v-col>
              <v-col class="pb-0 pt-0" lg="4" md="4" sm="12" cols="12">
                <p class="font-weight-black">ถนน</p>
                <v-text-field v-model="student_road" :rules="TextRule" label="ถนน..." single-line dense outlined clearable required></v-text-field>
              </v-col>
            </v-row>
            <!-- Line 1 ---------------------------------------------------------------------------------->
            <!-- Line 2 ---------------------------------------------------------------------------------->
            <v-row>
              <v-col class="pb-0 pt-0" lg="4" md="4" sm="12" cols="12">
                <p class="font-weight-black">ตำบล</p>
                <v-text-field
                  v-model="student_district"
                  :rules="TextRule"
                  label="ถนน..."
                  single-line
                  dense
                  outlined
                  clearable
                  required
                ></v-text-field>
              </v-col>
              <v-col class="pb-0 pt-0" lg="4" md="4" sm="12" cols="12">
                <p class="font-weight-black">อำเภอ</p>
                <v-text-field v-model="student_city" :rules="TextRule" label="ซอย..." single-line dense outlined clearable required></v-text-field>
              </v-col>
              <v-col class="pb-0 pt-0" lg="4" md="4" sm="12" cols="12">
                <p class="font-weight-black">จังหวัด</p>
                <v-select
                  v-model="student_province"
                  :items="provinceItem"
                  label="จังหวัด..."
                  item-value="province_id"
                  item-text="province_nameth"
                  :rules="[(v) => !!v || 'กรุณาเลือกจังหวัด']"
                  dense
                  outlined
                  required
                ></v-select>
              </v-col>
            </v-row>
            <!-- Line 2 ---------------------------------------------------------------------------------->

            <!-- Line 1 ---------------------------------------------------------------------------------->
            <v-row>
              <v-col class="pb-0 pt-0" lg="2" md="2" sm="12" cols="12">
                <p class="font-weight-black">รหัสไปรษณีย์</p>
                <v-text-field
                  v-model="student_zipcode"
                  :rules="TextRule"
                  label="รหัสไปรษณีย์..."
                  v-mask="{
                    mask: '#####',
                    unmaskedVar: 'student_zipcodeValue',
                  }"
                  single-line
                  dense
                  outlined
                  clearable
                  required
                ></v-text-field>
              </v-col>
              <v-col class="pb-0 pt-0" lg="3" md="3" sm="12" cols="12">
                <p class="font-weight-black">หมายเลขโทรศัพท์</p>
                <v-text-field
                  v-model="Mobile"
                  :rules="MobileRule"
                  label="หมายเลขโทรศัพท์..."
                  v-mask="{
                    mask: '(###) ###-####',
                    unmaskedVar: 'MobileValue',
                  }"
                  single-line
                  dense
                  outlined
                  clearable
                  required
                ></v-text-field>
              </v-col>
              <v-col class="pb-0 pt-0" lg="3" md="3" sm="12" cols="12">
                <p class="font-weight-black">Line ID</p>
                <v-text-field v-model="LineId" :rules="lineIdRule" label="Line ID..." single-line dense outlined clearable required></v-text-field>
              </v-col>
              <v-col class="pb-0 pt-0" lg="4" md="4" sm="12" cols="12">
                <p class="font-weight-black">Facebook</p>
                <v-text-field v-model="facebook" :rules="lineIdRule" label="Facebook..." single-line dense outlined clearable required></v-text-field>
              </v-col>
            </v-row>
            <!-- Line 1 ---------------------------------------------------------------------------------->
            <v-divider class="mt-5"></v-divider>
          </v-card>
          <!-- card 2 ------------------------------------------------------------------------------------------------------------>
          <!-- card 3 ------------------------------------------------------------------------------------------------------------>

          <v-card elevation="0">
            <v-toolbar flat class="mb-3">
              <v-toolbar-title class="flex text-center font-weight-black"> ศึกษาต่อที่ (Continue to Study) </v-toolbar-title>
            </v-toolbar>

            <v-col cols="12" sm="6" md="6">
              <v-radio-group v-model="radioEdu" row>
                <v-radio label="ไม่ศึกษาต่อ" color="orange" value="0"></v-radio>
                <v-radio label="ศึกษาต่อ" color="orange" value="1"></v-radio>
              </v-radio-group>
            </v-col>

            <div v-if="radioEdu === '1'">
              <!-- Line 1 ---------------------------------------------------------------------------------->
              <v-row>
                <v-col class="pb-0 pt-0" lg="6" md="6" sm="12" cols="12">
                  <p class="font-weight-black">ชื่อสถาบัน</p>
                  <v-text-field v-model="edu_name" label="ชื่อสถาบัน..." single-line dense outlined clearable></v-text-field>
                </v-col>
                <v-col class="pb-0 pt-0" lg="6" md="6" sm="12" cols="12">
                  <p class="font-weight-black">สาขาวิชา</p>
                  <v-text-field v-model="edu_faculty" label="สาขาวิชา..." single-line dense outlined clearable></v-text-field>
                </v-col>
              </v-row>
              <!-- Line 1 ---------------------------------------------------------------------------------->
              <!-- Line 2 ---------------------------------------------------------------------------------->
              <v-row>
                <v-col class="pb-0 pt-0" lg="4" md="4" sm="12" cols="12">
                  <!-- SM_EDULEVEL -->
                  <p class="font-weight-black">ระดับการศึกษา</p>
                  <v-select
                    v-model="edu_class"
                    :items="edu_classItem"
                    label="ระดับการศึกษา..."
                    item-value="edulevel_id"
                    item-text="edulevel_nameth"
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <v-col class="pb-0 pt-0" lg="4" md="4" sm="12" cols="12">
                  <p class="font-weight-black">จังหวัด</p>
                  <v-select
                    v-model="edu_province"
                    :items="provinceItem"
                    label="จังหวัด..."
                    item-value="province_id"
                    item-text="province_nameth"
                    dense
                    outlined
                  ></v-select>
                </v-col>
              </v-row>
              <!-- Line 2 ---------------------------------------------------------------------------------->
            </div>
            <v-divider class="mt-5"></v-divider>
          </v-card>
          <!-- card 3 ------------------------------------------------------------------------------------------------------------>
          <!-- card 4 ------------------------------------------------------------------------------------------------------------>
          <v-card elevation="0">
            <v-toolbar flat class="mb-3">
              <v-toolbar-title class="flex text-center font-weight-black"> สถานที่ทำงาน (Office) </v-toolbar-title>
            </v-toolbar>

            <v-col cols="12" sm="6" md="6">
              <v-radio-group v-model="radioWork" row>
                <v-radio label="ไม่ได้ทำงาน" color="orange" value="0"></v-radio>
                <v-radio label="ทำงาน" color="orange" value="1"></v-radio>
              </v-radio-group>
            </v-col>
            <div v-if="radioWork === '1'">
              <!-- Line 1 ---------------------------------------------------------------------------------->
              <v-row>
                <v-col class="pb-0 pt-0" lg="6" md="6" sm="12" cols="12">
                  <p class="font-weight-black">ชื่อสถานที่ทำงาน</p>
                  <v-text-field v-model="work_name" label="ชื่อสถานที่ทำงาน..." single-line dense outlined clearable></v-text-field>
                </v-col>
              </v-row>
              <!-- Line 1 ---------------------------------------------------------------------------------->
              <!-- Line 2 ---------------------------------------------------------------------------------->
              <v-row>
                <v-col class="pb-0 pt-0" lg="4" md="4" sm="12" cols="12">
                  <!-- SM_EDULEVEL -->
                  <p class="font-weight-black">สถานที่ทำงานเลขที่</p>
                  <v-text-field v-model="work_arrdress" label="สถานที่ทำงานเลขที่..." single-line dense outlined clearable></v-text-field>
                </v-col>
                <v-col class="pb-0 pt-0" lg="2" md="2" sm="12" cols="12">
                  <p class="font-weight-black">ซอย</p>
                  <v-text-field v-model="work_soi" :rules="TextRule" label="ซอย..." single-line dense outlined clearable></v-text-field>
                </v-col>
                <v-col class="pb-0 pt-0" lg="2" md="2" sm="12" cols="12">
                  <p class="font-weight-black">หมู่</p>
                  <v-text-field v-model="work_moo" :rules="TextRule" label="หมู่..." single-line dense outlined clearable></v-text-field>
                </v-col>
                <v-col class="pb-0 pt-0" lg="2" md="2" sm="12" cols="12">
                  <p class="font-weight-black">ถนน</p>
                  <v-text-field v-model="work_road" :rules="TextRule" label="ถนน..." single-line dense outlined clearable></v-text-field>
                </v-col>
                <v-col class="pb-0 pt-0" lg="2" md="2" sm="12" cols="12">
                  <p class="font-weight-black">ตำบล</p>
                  <v-text-field v-model="work_district" :rules="TextRule" label="ตำบล..." single-line dense outlined clearable></v-text-field>
                </v-col>
              </v-row>
              <!-- Line 2 ---------------------------------------------------------------------------------->
              <!-- Line 3 ---------------------------------------------------------------------------------->
              <v-row>
                <v-col class="pb-0 pt-0" lg="4" md="4" sm="12" cols="12">
                  <p class="font-weight-black">อำเภอ</p>
                  <v-text-field v-model="work_city" :rules="TextRule" label="อำเภอ..." single-line dense outlined clearable></v-text-field>
                </v-col>
                <v-col class="pb-0 pt-0" lg="4" md="4" sm="12" cols="12">
                  <p class="font-weight-black">จังหวัด</p>
                  <v-select
                    v-model="work_province"
                    :items="provinceItem"
                    label="จังหวัด..."
                    item-value="province_id"
                    item-text="province_nameth"
                    dense
                    outlined
                  ></v-select>
                </v-col>
              </v-row>
              <!-- Line 3 ---------------------------------------------------------------------------------->
              <!-- Line 4 ---------------------------------------------------------------------------------->
              <v-row>
                <v-col class="pb-0 pt-0" lg="4" md="4" sm="12" cols="12">
                  <p class="font-weight-black">ตำแหน่งงาน</p>
                  <v-text-field v-model="work_position" label="ตำแหน่งงาน..." single-line dense outlined clearable></v-text-field>
                </v-col>
                <v-col class="pb-0 pt-0" lg="3" md="3" sm="12" cols="12">
                  <p class="font-weight-black">เงินเดือน</p>
                  <v-text-field
                    v-model="work_salary"
                    label="เงินเดือน..."
                    v-mask="{
                      mask: '#######',
                      unmaskedVar: 'work_salaryValue',
                    }"
                    single-line
                    dense
                    outlined
                    reverse
                    suffix="฿"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
            <!-- Line 4 ---------------------------------------------------------------------------------->
            <v-divider class="mt-5"></v-divider>
            <v-card-actions class="justify-center">
              <v-btn large tile block class="btnSubmit" dark type="submit"> บันทึกข้อมูล </v-btn>
            </v-card-actions>
          </v-card>
          <!-- card 4 ------------------------------------------------------------------------------------->
        </v-form>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="800px">
        <v-card>
          <v-card-title class="d-flex justify-space-between align-center">
            <span class="text-h5">ข้อมูลโปรไฟล์นักเรียน</span>
            <span class="caption grey--text">({{ profiles.length }} คน)</span>
          </v-card-title>
          <v-card-text style="max-height: 60vh; overflow-y: auto">
            <v-card
              v-for="(person, index) in profiles"
              :key="index"
              outlined
              class="mb-3 pa-3"
              style="cursor: pointer"
              @click="getData(person.std_id)"
            >
              <v-row align="center" no-gutters>
                <!-- รูปโปรไฟล์ -->
                <v-col cols="auto" class="mr-4">
                  <v-avatar size="72" color="orange lighten-4">
                    <v-img v-if="person.imgUrl" :src="person.image" alt="profile"></v-img>
                    <v-icon v-else size="42" color="orange darken-2">mdi-account</v-icon>
                  </v-avatar>
                </v-col>

                <!-- ข้อมูล -->
                <v-col>
                  <!-- รหัสนักเรียน -->
                  <div class="caption grey--text">รหัสนักเรียน: {{ person.std_id || "-" }}</div>

                  <!-- ชื่อ - นามสกุล -->
                  <div class="font-weight-bold text-subtitle-1">{{ person.fullname || "-" }}</div>

                  <!-- ระดับชั้น -->
                  <div class="caption grey--text">ระดับชั้น: {{ person.studylevel || "-" }}</div>
                </v-col>

                <!-- สถานะ -->
                <v-col cols="auto">
                  <v-chip small :color="person.status === 'active' ? 'success' : 'grey'" dark>
                    {{ person.stdstatus_nameth || "-" }}
                  </v-chip>
                </v-col>
              </v-row>
            </v-card>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import api from "@/services/api";
import { mask } from "@titou10/v-mask";

export default {
  directives: { mask },
  name: "alumni",
  data() {
    return {
      valid: true,
      std_id: "",
      fullname: "",
      std_level: "",
      division: "",
      department: "",
      concentrate: "",
      zone: "",

      student_address: "",
      student_moo: "",
      student_soi: "",
      student_road: "",
      student_district: "",
      student_city: "",
      student_province: "",
      student_zipcode: "",
      student_zipcodeValue: "",
      Mobile: "",
      MobileValue: "",
      LineId: "",
      facebook: "",

      edu_name: "",
      edu_faculty: "",
      edu_class: "",
      edu_province: "",

      provinceItem: [],
      edu_classItem: [],

      work_name: "",
      work_arrdress: "",
      work_soi: "",
      work_moo: "",
      work_road: "",
      work_district: "",
      work_city: "",
      work_province: "",
      work_position: "",
      work_salary: "",
      work_salaryValue: "",

      radioEdu: "0",
      radioWork: "0",
      TextRule: [(v) => !!v || "กรุณากรอกข้อมูล", (v) => (v && v.length < 100) || "กรอกเกิน 100 ตัวอักษร"],
      MobileRule: [(v) => !!v || "กรุณากรอกข้อมูล", (v) => (v && v.length > 3) || "กรุณากรอกข้อมูลให้เกิน 3 ตัวอักษร"],
      lineIdRule: [(v) => (v && v.length > 3) || "กรุณากรอกข้อมูลให้เกิน 3 ตัวอักษร", (v) => (v && v.length < 30) || "กรุณากรอกเกิน 30 ตัวอักษร"],

      dialog: false,
      profiles: [],
      selectedProfile: null,
    };
  },
  async mounted() {
    await this.getProfile();
  },
  methods: {
    async getProfile() {
      try {
        let { data } = await api.alumni_getProfile();
        const raw = data.qProfile;
        this.profiles = Array.isArray(raw) ? raw : raw ? [raw] : [];
        this.dialog = true;
      } catch (error) {
        this.$store.dispatch("setDialog", {
          titlecolor: "titleDanger",
          title: "ผิดพลาด !!!",
          text: "กรุณาลองใหม่อีกครั้ง",
          width: 350,
        });
        console.log(error.response.data.msg);
      }
    },
    async getData(stdId) {
      try {
        this.selectedProfile = stdId;
        let result = await api.alumni_getData({ stdId });
        this.provinceItem = result.data.qProvince;
        this.edu_classItem = result.data.qEdulevel;

        //-----------------------------------------------------
        this.std_id = result.data.qData[0].std_id;
        this.fullname = result.data.qData[0].fullname;
        this.std_level = result.data.qData[0].studylevel;
        this.division = result.data.qData[0].division;
        this.department = result.data.qData[0].department;
        this.concentrate = result.data.qData[0].concentrate;
        this.zone = result.data.qData[0].zone;

        this.student_address = result.data.qData[0].id_address;
        this.student_moo = result.data.qData[0].id_moo;
        this.student_soi = result.data.qData[0].id_soi;
        this.student_road = result.data.qData[0].id_road;
        this.student_district = result.data.qData[0].id_district;
        this.student_city = result.data.qData[0].id_city;
        this.student_province = result.data.qData[0].id_province_id;
        this.student_zipcode = result.data.qData[0].id_zipcode;
        this.Mobile = result.data.qData[0].id_phone;
        this.LineId = result.data.qData[0].id_line_id;
        this.facebook = result.data.qData[0].id_facebook_url;

        this.edu_name = result.data.qData[0].edu_name;
        this.edu_faculty = result.data.qData[0].edu_faculty;
        this.edu_class = result.data.qData[0].edu_class;
        this.edu_province = result.data.qData[0].edu_province;
        this.radioEdu = result.data.qData[0].edu_status == "" ? "0" : result.data.qData[0].edu_status;

        this.work_name = result.data.qData[0].work_name;
        this.work_arrdress = result.data.qData[0].work_address;
        this.work_soi = result.data.qData[0].work_soi;
        this.work_moo = result.data.qData[0].work_moo;
        this.work_road = result.data.qData[0].work_road;
        this.work_district = result.data.qData[0].work_district;
        this.work_city = result.data.qData[0].work_city;
        this.work_province = result.data.qData[0].work_province;
        this.work_position = result.data.qData[0].work_position;
        this.work_salary = result.data.qData[0].work_salary;
        this.radioWork = result.data.qData[0].work_status == "" ? "0" : result.data.qData[0].work_status;

        //-----------------------------------------------------
        this.dialog = false;
      } catch (error) {
        this.$store.dispatch("setDialog", {
          titlecolor: "titleDanger",
          title: "ผิดพลาด !!!",
          text: "กรุณาลองใหม่อีกครั้ง",
          width: 350,
        });
        console.log(error.response.data.msg);
      }
    },
    async submit() {
      if (this.$refs.form.validate()) {
        if (this.radioEdu == "1") {
          if (this.edu_name == "" || this.edu_faculty == "" || this.edu_class == "" || this.edu_province == "") {
            this.$store.dispatch("setDialog", {
              titlecolor: "titleDanger",
              title: "ผิดพลาด !!!",
              text: "กรุณากรอกข้อมูลการศึกษาต่อให้ครบถ้วน",
              width: 350,
            });
            return;
          } //end if check edu
        } //end if check edu

        if (this.radioWork == "1") {
          if (
            this.work_name == "" ||
            this.work_arrdress == "" ||
            this.work_soi == "" ||
            this.work_moo == "" ||
            this.work_road == "" ||
            this.work_district == "" ||
            this.work_city == "" ||
            this.work_province == "" ||
            this.work_position == "" ||
            this.work_salaryValue == ""
          ) {
            this.$store.dispatch("setDialog", {
              titlecolor: "titleDanger",
              title: "ผิดพลาด !!!",
              text: "กรุณากรอกข้อมูลการทำงานให้ครบถ้วน",
              width: 350,
            });
            return;
          } //end if check edu
        } //end if check edu

        let data = {
          std_id: this.std_id,
          fullname: this.fullname,
          student_address: this.student_address,
          student_moo: this.student_moo,
          student_soi: this.student_soi,
          student_road: this.student_road,
          student_district: this.student_district,
          student_city: this.student_city,
          student_province: this.student_province,
          student_zipcodeValue: this.student_zipcodeValue,
          MobileValue: this.MobileValue,
          LineId: this.LineId,
          facebook: this.facebook,

          edu_name: this.radioEdu == "0" ? "" : this.edu_name,
          edu_faculty: this.radioEdu == "0" ? "" : this.edu_faculty,
          edu_class: this.radioEdu == "0" ? "" : this.edu_class,
          edu_province: this.radioEdu == "0" ? "" : this.edu_province,
          edu_status: this.radioEdu,

          work_name: this.radioWork == "0" ? "" : this.work_name,
          work_arrdress: this.radioWork == "0" ? "" : this.work_arrdress,
          work_soi: this.radioWork == "0" ? "" : this.work_soi,
          work_moo: this.radioWork == "0" ? "" : this.work_moo,
          work_road: this.radioWork == "0" ? "" : this.work_road,
          work_district: this.radioWork == "0" ? "" : this.work_district,
          work_city: this.radioWork == "0" ? "" : this.work_city,
          work_province: this.radioWork == "0" ? "" : this.work_province,
          work_position: this.radioWork == "0" ? "" : this.work_position,
          work_salaryValue: this.radioWork == "0" ? "" : this.work_salaryValue,
          work_status: this.radioWork,
        };
        try {
          await api.alumni_updateData(data);
          this.$store.dispatch("setSnackbar", {
            color: "success",
            text: "บันทึกข้อมูลสำเร็จ",
          });
          await this.getData(this.selectedProfile);
        } catch (error) {
          this.$store.dispatch("setDialog", {
            titlecolor: "titleDanger",
            title: "ผิดพลาด !!!",
            text: "กรุณาลองใหม่อีกครั้ง",
            width: 350,
          });
          console.log(error.response.data.msg);
        }
      }
    },
  },
};
</script>

<style></style>
